import { render, staticRenderFns } from "./DialogComanda.vue?vue&type=template&id=1b7dfd48&scoped=true&"
import script from "./DialogComanda.vue?vue&type=script&lang=js&"
export * from "./DialogComanda.vue?vue&type=script&lang=js&"
import style0 from "./DialogComanda.vue?vue&type=style&index=0&id=1b7dfd48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7dfd48",
  null
  
)

export default component.exports